export default __webpack_public_path__ + "static/centralCastingLogo-f0314026cc3f8791d2cf92bca6840ee3.jpg";